import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { i18n } from "../../translate/i18n";
import { Grid, Stack } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  btnWrapper: {
    position: "relative",
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

const statusOptions = [
  { value: "open", label: "Aberto", color: "#4caf50" },
  { value: "pending", label: "Pendente", color: "#ff9800" },
  { value: "closed", label: "Fechado", color: "#f44336" },
];

const FlowBuilderAddTicketStatusModal = ({ open, onSave, data, onUpdate, close }) => {
  const classes = useStyles();
  const isMounted = useRef(true);

  const [activeModal, setActiveModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("open");

  useEffect(() => {
    if (open === "edit") {
      const status = data?.data?.status || "open";
      setSelectedStatus(status);
      setActiveModal(true);
    } else if (open === "create") {
      setSelectedStatus("open");
      setActiveModal(true);
    }
    return () => {
      isMounted.current = false;
    };
  }, [open]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSave = () => {
    if (open === "edit") {
      onUpdate({
        ...data,
        data: {
          status: selectedStatus,
        },
      });
    } else if (open === "create") {
      onSave({
        status: selectedStatus,
      });
    }
    handleClose();
  };

  return (
    <div className={classes.root}>
      <Dialog
        open={activeModal}
        onClose={handleClose}
        fullWidth="md"
        scroll="paper"
      >
        <DialogTitle id="form-dialog-title">
          {open === "create"
            ? "Adicionar Status do Ticket"
            : "Editar Status do Ticket"}
        </DialogTitle>
        <Stack>
          <DialogContent dividers>
            <Grid style={{ width: "100%", marginTop: 10 }} container>
              <Typography>
                Escolha o status que deseja definir para o ticket
              </Typography>
              <Select
                value={selectedStatus}
                style={{ width: "95%", marginTop: 10 }}
                onChange={(e) => setSelectedStatus(e.target.value)}
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
                renderValue={() => {
                  const opt = statusOptions.find(
                    (o) => o.value === selectedStatus
                  );
                  return (
                    <span style={{ color: opt?.color, fontWeight: "bold" }}>
                      {opt?.label || selectedStatus}
                    </span>
                  );
                }}
              >
                {statusOptions.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    <span style={{ color: opt.color, fontWeight: "bold" }}>
                      {opt.label}
                    </span>
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary" variant="outlined">
              {i18n.t("contactModal.buttons.cancel")}
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              className={classes.btnWrapper}
              onClick={handleSave}
            >
              {open === "create" ? "Adicionar" : "Editar"}
            </Button>
          </DialogActions>
        </Stack>
      </Dialog>
    </div>
  );
};

export default FlowBuilderAddTicketStatusModal;
